export const SOCIALS = {
    mx: 'https://max.ru/u/f9LHodD0cOJHj2Mcq5ZyffO4TIiEXyojnFlJkmeZ8aNlxnJvJBrtvPIEZpc',
    vk: '',
    tg: 'tg://resolve?phone=79257879505',
    ig: '',
    wa: 'https://wa.me/79257879505',
} as const;

export const GENDER = [
    // old
    {
        id: '1',
        name: 'Унисекс',
        url: 'unisex',
    },
    {
        id: '2',
        name: 'Женский',
        url: 'female',
    },
    {
        id: '3',
        name: 'Мужской',
        url: 'male',
    },
];
